/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_typing_hub_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why does a single mistake lower my WPM more than expected?`)
};

const es_typing_hub_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Por qué un solo error baja mi WPM más de lo esperado?`)
};

const de_typing_hub_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warum senkt ein einzelner Fehler meine WPM stärker als erwartet?`)
};

const nl_typing_hub_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waarom verlaagt één fout mijn WPM meer dan verwacht?`)
};

const fr_typing_hub_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pourquoi une seule erreur fait-elle baisser mon WPM plus que prévu ?`)
};

const it_typing_hub_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perché un solo errore abbassa il mio WPM più del previsto?`)
};

const pt_br2_typing_hub_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por que um único erro reduz meu WPM mais do que eu esperava?`)
};

const pt_typing_hub_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porque é que um único erro reduz o meu WPM mais do que esperado?`)
};

const ja_typing_hub_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`なぜ1つのミスがWPMを予想以上に下げるのですか？`)
};

const zh_typing_hub_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为什么一个错误会让我的WPM下降得比预期更多？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const typing_hub_faq4_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.typing_hub_faq4_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("typing_hub_faq4_q", locale)
	if (locale === "en") return en_typing_hub_faq4_q(inputs)
	if (locale === "es") return es_typing_hub_faq4_q(inputs)
	if (locale === "de") return de_typing_hub_faq4_q(inputs)
	if (locale === "nl") return nl_typing_hub_faq4_q(inputs)
	if (locale === "fr") return fr_typing_hub_faq4_q(inputs)
	if (locale === "it") return it_typing_hub_faq4_q(inputs)
	if (locale === "pt-BR") return pt_br2_typing_hub_faq4_q(inputs)
	if (locale === "pt") return pt_typing_hub_faq4_q(inputs)
	if (locale === "ja") return ja_typing_hub_faq4_q(inputs)
	return zh_typing_hub_faq4_q(inputs)
};